import { render, staticRenderFns } from "./DeliveryHistoryCard.vue?vue&type=template&id=e333f808&scoped=true"
import script from "./DeliveryHistoryCard.vue?vue&type=script&lang=js"
export * from "./DeliveryHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryHistoryCard.vue?vue&type=style&index=0&id=e333f808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e333f808",
  null
  
)

export default component.exports